/* eslint-disable react/prop-types */
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function EmailConfirmationModal({ isOpen, onClose }) {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    if (isOpen) {
      setShow(true);
    }
  }, [isOpen]);

  const handleClose = () => {
    setShow(false);
    if (onClose) {
      onClose();
    }
    navigate('/login', { replace: true });
  };

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title className="blue-title">Email Confirmation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        A verification link has been sent on email id provided by you.
        Please verify it. Its verification link is valid for 10 min.
      </Modal.Body>
      <Modal.Footer>
        <Button className="bg-primary" variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default EmailConfirmationModal;
